<script>
export default {
  delimiters: ['${', '}'],
  template: '<span style="display: none"><slot></slot></span>',
  props: {
    link: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    funnel: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    order: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    val: String,
    relatedVal: String,
    lookup: String,
    relatedLookup: String,
    flag: String,
    extraVal: String,
    action: String,
    extraLookup: String,
    innerClass: String,
    lightbox: String,
    // `class` seems to be ignored
    class: String,
    tooltip: String,
    idx: Number,
    cols: Array,
    filter: Function,
    datasetField: Array
  },
  created: function () {
    this.$parent.loadHeading(this)
  }
}
</script>


// WEBPACK FOOTER //
// SheetLine.vue?6b2a631b